import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { companiesApi } from '../../api/services';
import { setCompanies, NO_COMPANY } from '../../store';
import { saveAs } from 'file-saver';

/** Kompanije za prozor izveštaja: kao stari klijent, lista se ponovo učitava pri otvaranju, a podrazumevana
    je prva kompanija (postavlja se i kad lista stigne posle otvaranja). withNoCompany: uključuje "Bez kompanije". */
export function useReportCompanies(withNoCompany) {
    const dispatch = useDispatch();
    const all = useSelector((s) => s.companies.list);
    const companies = withNoCompany ? all : all.filter((c) => c.id != null);
    const [company, setCompany] = useState(companies[0] || null);
    useEffect(() => {
        companiesApi.all().then((l) => dispatch(setCompanies([NO_COMPANY, ...l]))).catch(() => {});
    }, [dispatch]);
    useEffect(() => {
        setCompany((c) => (c && companies.find((x) => x.id === c.id)) || companies[0] || null);
    }, [all]);
    return { companies, company, setCompany };
}

/* Status generisanja (progress bar na dnu prozora): 0% -> 100%. */
export function useReportStatus() {
    const [state, setState] = useState({ text: '', percent: 0, busy: false });
    return {
        state,
        start: () => setState({ text: 'Generisanje u toku', percent: 0, busy: true }),
        done: () => setState({ text: 'Generisanje završeno', percent: 100, busy: false }),
        fail: () => setState({ text: 'Generisanje neuspelo', percent: 0, busy: false }),
    };
}

/** Čita poruku greške iz blob odgovora (server šalje text/plain). */
export const blobError = async (err) => {
    const data = err && err.response && err.response.data;
    if (data instanceof Blob) {
        const text = await data.text();
        try { return JSON.parse(text).message || text; } catch { return text; }
    }
    return err.message;
};

/** Preuzimanje blob odgovora kao fajla sa zadatim imenom. */
export const download = (response, filename) => {
    if (!response || !response.data || !response.data.size) {
        throw new Error('Greška prilikom eksporta tabele, servis nije vratio nijedan rezultat');
    }
    saveAs(response.data, filename);
};

/** Cele greške izveštaja se prikazuju kroz toast, ne kroz globalni interceptor (blob telo). */
export const REPORT_REQ = { silent: true };
